import styled from "styled-components";

export const MobileMenuFixedStyled = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;

    box-shadow: var(--shadow-bottom-overlay);
    background: var(--color-background-primary);
    z-index: 9;
    &.bg-transparent,
    .bg-transparent {
        background-color: transparent !important;
        box-shadow: none !important;
    }
    &.bg-surface,
    .bg-surface {
        background-color: var(--color-background-secondary-to-primary);
        box-shadow: none;
    }
`;

export const MobileMenuStyled = styled.div`
    display: flex;
    flex-direction: row;
    
    a {
        color: unset;
        text-decoration: none;
    }
`;

export const MobileMenuItemStyled = styled.div`
    text-align: center;
    flex: 1;
    color: var(--color-label-primary);
    font-size: 14px;
    font-weight: 600;
    padding: 8px 0;
    padding-bottom: 16px;
    
    a {
        display: block;
    }
    
    svg, .title {
        opacity: 0.5;
    }
    
    &.active {
        svg, .title {
            opacity: 1;
        }
    }
`;

export const MobileMenuItemBadgeStyled = styled.div`
    position: absolute;
    height: 6px;
    width: 6px;
    border-radius: 6px;
    background: var(--color-negative);
    top: 0;
    right: 0;
`;
